import React from 'react'

const BeemzText = () => {
    return (
        <div className='d-flex text-lowercase'>
            <span>be</span>
            <span className="reverse_text">e</span>
            <span>mz</span>
        </div>
    )
}

export default BeemzText